import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const NotTagPropertyWrapper = styled.div`
  flex: 1;
  .field-input {
    width: 100%;
    border-radius: 8px;
    padding: 4px 0px 4px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    & .MuiInput-input {
      padding: 0px;
    }
    & .MuiSelect-select {
      padding: 4.5px 8px;
      display: inline;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .MuiTypography-root {
        font-size: 14px;
      }
    }
    & .MuiAutocomplete-inputRoot {
      padding: 0px;
    }
  }
  .no-padding {
    padding: 0px;
  }
  .field-input.field-disabled:hover {
    background: transparent !important;
  }
  .text-area.field-disabled:hover {
    background: transparent !important;
  }
  .text-area-no-border.field-disabled:hover {
    background: transparent !important;
  }
  /* Override MUI hover effects for disabled fields */
  .field-disabled {
    &:hover {
      background: transparent !important;
    }
    & .MuiInputBase-root:hover {
      background: transparent !important;
    }
    & .MuiSelect-select:hover {
      background: transparent !important;
    }
    & .MuiAutocomplete-inputRoot:hover {
      background: transparent !important;
    }
    & .MuiOutlinedInput-root:hover {
      background: transparent !important;
    }
  }
  .text-area {
    display: flex;
    width: 100%;
    min-height: 30px !important;
    max-height: 100px !important;
    border-color: ${colors.grey444};
    padding: 5px;
    resize: none;
    border-radius: 8px;
    font-family: inherit;
    font-size: 14px;
    &:focus {
      outline: none;
    }
    &::placeholder {
      color: #a2a2a2;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.5px;
    }
  }
  &.ai-variable-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 8px;
    border: 1px solid ${colors.grey444};
    height: 100px;
    resize: vertical;
    overflow-y: hidden;
    min-height: 60px;

    .text-area-no-border {
      display: flex;
      width: 100%;
      min-height: 30px !important;
      overflow: auto !important;
      border: none;
      padding: 5px;
      resize: none;
      border-radius: 8px;
      font-family: inherit;
      font-size: 14px;
      flex: 1;
      &.max-height-limit {
        max-height: 90px !important;
        overflow: hidden !important;
      }
      &:focus {
        outline: none;
      }
      &::placeholder {
        color: #a2a2a2;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0.5px;
      }
    }
    .actions-container {
      display: flex;
      align-items: center;
      align-self: flex-end;
      gap: 4px;
      padding: 2px 16px 8px 16px;
      .action-icon {
        cursor: pointer;
      }
    }
    .empty-cell {
      display: flex;
      align-items: center;
      gap: 4px;
      margin: 2px 0px 0px 2px;
      border-radius: 16px;
      color: ${colors.primaryDark};
      padding: 2px 4px;
      width: max-content;
      cursor: pointer;
      background: ${colors.rewriteCreditsLight};

      :hover {
        color: ${colors.darkGreenHover};
        background: ${colors.rewriteCreditsBackground};

        div {
          background: ${colors.rewriteCreditsBackground};
        }
      }

      &--insufficient {
        color: ${colors.inactiveHover} !important;
        background: ${colors.inactiveLight} !important;
        cursor: default;
        gap: 2px;

        &:hover {
          background: ${colors.inactiveLightHover} !important;

          div {
            background: ${colors.inactiveLightHover} !important;
          }
        }
      }
    }
    .loader-container {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 8px;
      .loader-div {
        width: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        .loader {
          transform: scale3d(0.3, 0.3, 1);
        }
      }
    }
    .enrich-error {
      display: flex;
      gap: 4px;
      align-items: flex-start;
      padding: 8px;
      color: ${colors.inactive};
      overflow: hidden;
      flex: 1;
      .enriching-lable-info-box {
        display: flex;
        align-items: center;
        gap: 4px;
        overflow: hidden;
      }
      :hover {
        color: ${colors.inactiveHover};
      }
      .error-icon {
        &.pointer {
          cursor: pointer;
        }
        > path {
          stroke: ${colors.inactive};
        }
        :hover {
          > path {
            stroke: ${colors.inactiveHover};
          }
        }
        &.regenerate {
          filter: grayscale(1);
          :hover {
            filter: grayscale(0);
          }
        }
      }
    }
    .icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  /* .text-area:hover {
    background: ${colors.grey6};
  } */
  .no-min-height {
    min-height: unset !important;
  }
  .text-field {
    width: 100%;
    height: 32px;
  }
  .editable-div {
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 26px !important;
    height: 30px !important;
    padding-left: 4px;
  }
  .editable-div > span > svg {
    opacity: 0;
  }
  .editable-div:hover > span > svg {
    opacity: 1;
  }
  .editable-div > div > span {
    opacity: 0;
  }
  .editable-div > div > div > input:focus ~ .editable-div {
    background: ${colors.inactive};
  }
  .editable-div:hover > div > span {
    opacity: 1;
  }
`;

export const StyledEPWrapper = styled.div`
  .text-area {
    display: flex;
    width: 100%;
    min-height: 30px !important;
    max-height: 90px !important;
    padding: 5px;
    border: none;
    resize: none;
    border-radius: 8px;
    font-family: inherit;
    font-size: 14px;
    &:focus {
      outline: none;
    }
    &::placeholder {
      color: #a2a2a2;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.5px;
    }
  }
  .text-area.field-disabled:hover {
    background: transparent !important;
  }
`;
